export const FileTypeCategory = {
  IMAGE: 'image',
  PDF: 'pdf',
  VIDEO: 'video',
  DOCUMENT: 'document',
  SPREADSHEET: 'spreadsheet',
  OTHER: 'other',
} as const;

export type FileTypeCategoryValue =
  (typeof FileTypeCategory)[keyof typeof FileTypeCategory];

export const MIME_TYPE_CATEGORIES: Record<string, FileTypeCategoryValue> = {
  'image/jpeg': FileTypeCategory.IMAGE,
  'image/jpg': FileTypeCategory.IMAGE,
  'image/png': FileTypeCategory.IMAGE,
  'image/webp': FileTypeCategory.IMAGE,
  'image/heic': FileTypeCategory.IMAGE,
  'image/heif': FileTypeCategory.IMAGE,
  'image/gif': FileTypeCategory.IMAGE,
  'image/svg+xml': FileTypeCategory.IMAGE,
  'application/pdf': FileTypeCategory.PDF,
  'video/mp4': FileTypeCategory.VIDEO,
  'video/quicktime': FileTypeCategory.VIDEO,
  'video/webm': FileTypeCategory.VIDEO,
  'video/x-msvideo': FileTypeCategory.VIDEO,
  'application/msword': FileTypeCategory.DOCUMENT,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    FileTypeCategory.DOCUMENT,
  'text/plain': FileTypeCategory.DOCUMENT,
  'text/rtf': FileTypeCategory.DOCUMENT,
  'application/vnd.ms-excel': FileTypeCategory.SPREADSHEET,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    FileTypeCategory.SPREADSHEET,
  'text/csv': FileTypeCategory.SPREADSHEET,
};

export function getFileCategory(mimeType: string): FileTypeCategoryValue {
  if (mimeType.startsWith('image/')) return FileTypeCategory.IMAGE;
  if (mimeType.startsWith('video/')) return FileTypeCategory.VIDEO;
  return MIME_TYPE_CATEGORIES[mimeType] || FileTypeCategory.OTHER;
}
